export default function NotFound() {
    return <div>Stránka nenalezena</div>;
}
